module.exports = __webpack_public_path__ + "static/flags/MP-cf0cd851e98b5f316987de8208f9bf3f.gif";